<template>
  <div class="app-container">
    <div class="main-content">
      <Header />
      <keep-alive>
        <router-view :key="viewKey" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="viewKey"></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { EventBus } from './api/eventBus';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data(){
    return {
      viewKey:0,
    }
  },
  created() {
    EventBus.$on('clear-cache', this.clearCache);
  },
  beforeDestroy() {
    EventBus.$off('clear-cache', this.clearCache);
  },
  methods: {
    clearCache() {
      this.viewKey += 1;
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

footer {
  background-color: #f8f9fa;
  padding: 20px;
  text-align: center;
}
</style>
